module.exports = __webpack_public_path__ + "static/media/ic_mic.bbb78944.svg";